$ = jQuery;

/*Functions*/

/**
 * Google Rating
 */
function starsHover() {
    var ratingInner = $(".stars_rating.g_rating .g_rating_inner"),
        ratingInnerWidth = ratingInner.innerWidth(),
        ratingBlock = $(".stars_rating.g_rating"),
        id = $(".g_rating_block .count_number").attr('data-id');
    ratingCount = $(".g_rating_block .count_number span");
    ratingBlock.on("click", function () {
        if (!getCookie('added_rating' + id) && !$(this).data("clicked")) {
            ratingCount.text(parseInt(ratingCount.html()) + 1);
            console.log(ratingCount.html());
            var data = {
                'action': 'add_rating_count',
                'count': ratingCount.html(),
                'id': id
            };
            $.ajax({
                url: '/wp-admin/admin-ajax.php',
                data: data,
                type: 'POST',
                success: function (data) {
                    if (data) {
                        ratingCount.text(data);
                    }
                }
            });
        }
        setCookie('added_rating' + id, 'true', 10);
        $(this).data("clicked", !0)
    });
    if (!getCookie('added_rating' + id) && !$(this).data("clicked")) {
        ratingBlock.on("mousemove", function (e) {
            if (!$(this).data("clicked")) {
                var ratingInnerWidth = e.clientX - $(this).offset().left;
                ratingInner.css("width", ratingInnerWidth)
            }
        });
        ratingBlock.on("mouseleave", function (e) {
            ratingInner.css("width", ratingInnerWidth)
        })
    }
}

/*Scroll top*/
var $toTopSelector = $("#to_top");

function showScrollTop() {
    if ($(this).scrollTop() > 100) {
        $toTopSelector.addClass('active');
    } else {
        $toTopSelector.removeClass('active');
    }
}


/**
 * Payments visibility switcher
 */
$('.js-payments-switcher').on('click', function (e) {
    e.stopImmediatePropagation();
    $(this).parent('.js-payments').find('.image-box__hidden').removeClass('image-box__hidden');
    $(this).hide();
});

/**
 * Redirection logo img
 */
function logoToReferral() {
    var logoReferral = $('.logo-referral');

    logoReferral.on('click', makeRefHandler({
        refKey: 'refer'
    }));
}

function bootTableRowReferralLinks() {
    var $tableRow = $('.js-casinos-overlay');

    // $tableRow.on('click', makeRefHandler({
    //     refKey: 'casino-target'
    // }));
}

/**
 * Redirection Button
 */
function toReferral() {
    var btn = $('button.referral'), logo = $('.table-image-wrap span.referral');

    // btn.on('click', makeRefHandler());
    // logo.on('click', makeRefHandler());

}



function closeModal() {
    $('.js-modal-close').trigger('click');
}

$(document).on('keyup', function (e) {
    var isModal = $('.js-backdrop').hasClass('visible');
    if (e.key === 'Escape' && isModal) {
        closeModal();
    }
});

const REDIRECT_BASE = '/to-casino';
$('.js-casinos-overlay, button.referral').on('click', function (e) {
    const linkGenerated = getRefLinkHandler($(this), e);
    if (e.target.nodeName === 'A') {
        e.stopImmediatePropagation();
    } else if (e.target.nodeName === 'IMG' && !$(e.target).parent().hasClass('referral')) {
        e.stopImmediatePropagation();
    } else if (e.target.nodeName === 'IMG' && $(e.target).parent().hasClass('referral') || $(e.target).hasClass('casino-table__permalink') || $(e.target).hasClass('casino-table__thumb') || $(e.target).hasClass('casino-table__btn') || e.target.nodeName === 'BUTTON') {
        e.stopImmediatePropagation();

        if (linkGenerated) {
            e.preventDefault();

            window.open(linkGenerated);
        }
    } else {
        e.preventDefault();
        e.stopImmediatePropagation();
        let goTo = linkGenerated;
        if (goTo) {
            window.open(goTo);
        }
    }
});

$(function () {
    "use strict";

    var $siteBody = $("body");

    // Boot refferal links
    logoToReferral();
    toReferral();
    bootTableRowReferralLinks();

    /*Init*/
    $siteBody.addClass(currentBrowser()).addClass(detectmob());
    showScrollTop();
    $(window).on('scroll', function () {
        showScrollTop();
    });

    if ($('.single-kasyno').length > 0) {
        $('.single-casinos-popup').fadeIn(500).css({'display': 'flex'});
        $siteBody.on('click touchstart', function (event) {
            if ('ignore-popup' !== event.target.getAttribute('data-pointer-event')) {
                $('.single-casinos-popup').fadeOut(500);
            }
        });
        $('.popup-wrapper').on('click touchstart', function (e) {
            e.stopPropagation();
        });
        $('.close-popup').on('click', function (e) {
            e.stopPropagation();
            $('.single-casinos-popup').fadeOut(500);
        });
    }

    $('.block_expand span').on('click', function () {
        $('.casino_fixed_block').toggleClass('active');
        $('.block_expand').toggleClass('active');
    });

    /**
     * Close pop-up window (CPT Slots)
     */
    $('.js-modal-close').on('click', function () {
        $(this).closest('.js-modal').removeClass('visible');
        $('body').css('overflow', 'auto');
    });

    $('.js-modal').on('click', function (e) {
        if ($(e.target).hasClass('js-backdrop')) {
            closeModal();
        }
    });

    /**
     * Add GA cid to CF7 hidden field
     */
    addGAToCF7();

    /**
     * Table mobile open
     */
    $('.for_expand').on('click', function () {
        if ($(this).hasClass('active')) {
            $(this).parent().prev().removeClass('active');
            $(this).removeClass('active');
        } else {
            $(this).parent().prev().addClass('active');
            $(this).addClass('active');
        }
    });
    if ($(".g_rating")[0]) {
        starsHover();
    }
    /*Events*/
    if ($(".sidebar_fix")[0] && $(window).width() > 1024) {
    }
    /*Scroll top Click*/
    $("#to_top").on("click", "span", function () {
        $('html, body').animate({scrollTop: 0}, 1000);
    });

    /*Menu*/
    // $("#menuOpen button.hamburger").on('click',function (e) {
    //     $('#mainMenu').toggleClass("opened");
    //     $(this).parent().toggleClass("opened");
    //     $(this).toggleClass('is-active');
    //     siteBody.toggleClass('shadow');
    // });
    // $('#mainMenu li.menu-item-has-children').append('<span class="subMenuButton i-angle-down"></span>');
    // $('.subMenuButton').on('click',function () {
    //     var t = $(this);
    //     if(t.hasClass('open')) {
    //         t.removeClass('open').prev().slideUp(300);
    //     } else {
    //         t.removeClass('open').prev().slideDown(300);
    //         t.addClass('open');
    //     }
    // });
    // //Menu Close
    // $(document).mouseup(function (e){
    //     var div = $("#mainMenu,#menuOpen");
    //     if (!div.is(e.target)
    //         && div.has(e.target).length === 0) {
    //         div.removeClass('opened');
    //         $('.hamburger').removeClass('is-active');
    //         siteBody.removeClass('shadow');
    //     }
    // });

    //WPCF7
    $(this).on('click', '.wpcf7-not-valid-tip', function () {
        $(this).prev().trigger('focus');
        $(this).fadeOut(500, function () {
            $(this).remove();
        });
    });
    //Privacy
    if (!getCookie('privacy')) {
        var privacy = $('#privacy');
        privacy.show();
    }
    $('#privacy .button_close').on('click', function () {
        $('#privacy').addClass('hide');
        setCookie('privacy', 'true', 1);
    });

    /**
     * FAQ
     */
    var $faqListTitle = $('.faq_list_item .faq_list_title');
    $faqListTitle.on('click', function () {
        if ($(this).hasClass('opened')) {
            $('.faq_list_item .faq_list_title').removeClass('opened');
            $(this).next().slideToggle(300);
            $('.faq_list_item').find('.faq_list_info').slideUp(300);
        } else {
            $('.faq_list_item').find('.faq_list_info').slideUp(300);
            $(this).next().slideToggle(300);
            $('.faq_list_item .faq_list_title').removeClass('opened');
            $(this).addClass('opened');
        }
    });
    $faqListTitle.eq(0).trigger('click');

    if ($siteBody.hasClass('page-template-tpl-services')) {
        setTimeout(function () {
            $('.faq_list_item .faq_list_title').eq(0).trigger('click');
        }, 5000);
    }
});

$('.table-show-all').on('click', function () {
    var $parent = $(this).parent();
    if ($(this).hasClass('active')) {
        $(this).removeClass('active');
        // $('.table-hide-more').hide(500);
        $parent.find('.table-hide-more-mobile').removeClass('show');
        $parent.find('.table-hide-more').removeClass('show');
        $parent.find('.table-show-all__expand span').html('Pokaż więcej kasyn');
        if ($parent.hasClass('big-table-wrapper')) {
            console.log('big-table-wrapper');
            $([document.documentElement, document.body]).animate({
                scrollTop: $parent.offset().top
            }, 1000);
        } else {
            // console.log($parent);
            $([document.documentElement, document.body]).animate({
                scrollTop: $parent.offset().top - 120
            }, 1000);
        }

    } else {
        $(this).addClass('active');
        // $('.table-hide-more').show(500);
        $parent.find('.table-hide-more-mobile').addClass('show');
        $parent.find('.table-hide-more').addClass('show');
        $parent.find('.table-show-all__expand span').html('Ukryj dodatkowe kasyno');
    }
});


var fun = function () {

    var loadmore = $(this),
        cur = loadmore.attr('data-page'),
        data = {
            'action': 'loadmore',
            'query': loadmore.attr('data-true-posts'),
            'page': cur
        };
    $.ajax({
        url: ajaxurl,
        data: data,
        type: 'POST',
        success: function (data) {
            if (data) {
                loadmore.before(data);
                cur = parseInt(cur) + 1;
                loadmore.attr('data-page', cur);
                if (cur === parseInt(loadmore.attr('data-max-pages'))) loadmore.remove();
            } else {
                loadmore.remove();
            }
        }
    });
};
$('.true_loadmore').on('click', fun);

$('.js-slot-link').on('click', function () {
    var $modal = $('.js-modal');
    $modal.addClass('js-backdrop');
    var slotName = $(this).closest('.js-label').data('label');

    dataLayer.push({
        'event': 'GAevent',
        'eventCategory': 'Slot-error',
        'eventAction': 'User-report',
        'eventLabel': slotName
    });
    $modal.addClass('visible');
    $('body').css('overflow', 'hidden');
});

if ($(window).width() < 767) {
    $('.single_thumb').css('background-image', 'none');
}

const fixedBlock = $('.casino_fixed_block');
const header = $('header');
const isSticky = header.length ? header.css('position') === 'sticky' : false;
const headerHeight = header.length ? header.outerHeight() : 0;

if (fixedBlock.length) {
    if (isSticky) {
        fixedBlock.css('top', headerHeight + 'px');
    }

    $(window).on('scroll', function () {
        if ($(window).scrollTop() > 500) {
            fixedBlock.addClass('show-mob');
        } else {
            fixedBlock.removeClass('show-mob');
        }
    });
}


function addGAToCF7() {
    var _cid = getCookie('_ga');
    var cid = _cid.toString().replace('GA1.2.', '');
    var cid = _cid.toString().replace('GA1.1.', '');
    var url = window.location.href;

    $('.js-hidden-referrer').val(url);
    $('.js-hidden-ga').val(cid);
}


$('.flip-card_banking').each(function () {
    var elems = $('.item', this);
    var len = elems.length;
    // for( i = 0; i < len; i++ ){
    //   if(i >= 5){
    //    elems.eq(i).hide();
    //    }
    //  }
    if ($(window).width() >= 991 && len > 5) {
        hiddenElems = len - 5;

        $(this).append(
            '<span class="btn-show">+'
            + hiddenElems +
            '</span>'
        );
    }


    if ($(window).width() < 991 && len > 3) {
        hiddenElems = len - 3;

        $(this).append(
            '<span class="btn-show">+'
            + hiddenElems +
            '</span>'
        );
    }

    $('.btn-show').on('click', function () {
        var self = $(this).parent('.flip-card_banking');
        $('.flip-card_banking').removeClass('active');
        self.toggleClass('active');
        return false;
    });

});

$(function () {
    var table_t_c = $('.js-table_t_c_text_td_desktop');
    if (table_t_c) {
        for (var table_t_c_i = 0; table_t_c_i < table_t_c.length; table_t_c_i++) {
            $(table_t_c[table_t_c_i])
                .html($(table_t_c[table_t_c_i])
                    .data('text'))
                .attr('data-text', '');
        }
    }
});

$(function () {
    $('.wrapless-content-wrap table').wrap('<div class="table-wrap"></div>');
});


$('.slot-demo-popup-js').on('click', function () {

    let dataIframe = $(this).data('iframe');
    let sandbox = $(this).attr('sandbox');

    if (dataIframe) {
        $('.js-iframe-img').fadeOut('slow');
        if (sandbox) {
            $('.js-slot-demo-full-frame').html(
                "<iframe frameborder='0' sandbox='" + sandbox + "' src='" + dataIframe + "'></iframe>"
            );
        } else {
            $('.js-slot-demo-full-frame').html(
                "<iframe frameborder='0' src='" + dataIframe + "'></iframe>"
            );
        }
    }
});

function addListenersToCopyButtons() {
    const buttons = document.querySelectorAll('.js-to-clipboard');

    if (!buttons) {
        return;
    }

    buttons.forEach(button => {
        const response = button.parentNode.nextElementSibling;

        button.addEventListener('click', async event => {
            const copiedValue = event.currentTarget.dataset.clipboardValue;

            await navigator.clipboard.writeText(copiedValue);

            if (response.classList.contains('js-response-clipboard')) {
                response.style.display = 'block';

                setTimeout(() => {
                    response.style.display = 'none';
                }, 2000);
            }
        })
    });
}

addListenersToCopyButtons();
